module.exports = __webpack_public_path__ + "static/media/bulb.b4e26650.svg";